export default "__VITE_ASSET__ByqlvyVq__"